import React, { PureComponent } from 'react';
import { createContainer } from '@dbk-legacy/muster/react';
import Button from '@dbk/ui-buttons';
import { InstatntMessenger } from '@dbk/ui-icons';
import { Large, H3, H2 } from '@dbk/ui-text';
import BlurModal from '../../../components/common/blur-modal';
import TermsAndConditions from './chat-tc';
import { PALETTE } from '../../../constants';

class ChatWelcomeScreen extends PureComponent {
  constructor() {
    super();
    this.state = {
      showTermsAndConditions: false,
    };
    this.startNowClicked = this.startNowClicked.bind(this);
    this.closeButtonClicked = this.closeButtonClicked.bind(this);
    this.renderWelcomeScreen = this.renderWelcomeScreen.bind(this);
  }

  startNowClicked() {
    this.setState({ showTermsAndConditions: true });
  }

  closeButtonClicked() {
    this.props.chat.setShowWelcomeScreen(false);
  }

  renderWelcomeScreen() {
    const {
      i18n: { messages }
    } = this.props;
    return (
      <div className="docsign esign-banner-root margin-left-35 margin-right-35">
        <div className="esign-banner-welcome-message">
          <H3 secondary>{messages['app.chat.welcomeScreen.welcome']}</H3>
        </div>
        <div className="esign-banner-title row large-12 margin-top-10 margin-bottom-10">
          <InstatntMessenger className="banner-title-icon" width={50} height={50} />
        </div>
        <div className="esign-banner-welcome-message">
          <H2 secondary>{messages['app.chat.welcomeScreen.title']}</H2>
        </div>
        <div className="center-content">
          <Large className="docsign-instruction-text text-center instructions-block" secondary>
            {messages['app.chat.welcomeScreen.description']}
          </Large>
        </div>
        <div className="large-12 docsign-banner-buttons">
          <Button className="docsign-accept-button large-4" onPress={this.startNowClicked}>
            {messages['app.chat.welcomeScreen.button']}
          </Button>
        </div>
        <div className="chat-banner-notnow" style={{ color: PALETTE.primaryActive }} onClick={() => this.closeButtonClicked()}>
          {messages['app.edelivery.notNow']}
        </div>
      </div>
    );
  }

  render() {
    const { showTermsAndConditions } = this.state;
    const {
      i18n: { messages }
    } = this.props;

    return (
      <BlurModal
        visible
        onDone={this.closeButtonClicked}
        title={showTermsAndConditions && messages['app.chat.termsAndConditions.header']}
        disableOutsideClick={showTermsAndConditions} >
        {showTermsAndConditions ?
          <TermsAndConditions />
          :
          this.renderWelcomeScreen()
        }
      </BlurModal>
    )
  }
}

export default createContainer({
  $queries: {
    chat: {
      setShowWelcomeScreen: { $set: 'showWelcomeScreen' },
    },
    i18n: { messages: true },
    rsa: {
      rsaAuthorised: true,
      onChangePage: {
        $call: 'changePage',
      },
    },
  },
})(ChatWelcomeScreen);
